import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    
    /* text-base/Medium */
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
`;

const RepresentativeWrapper = styled.div`
   width: 100%;
   height: fit-content;
   display: flex;
   flex-direction: column;
`;

const RepresentativeTitle = styled.div`
    margin-bottom: 16px;
    /* text-lg/Medium */
    font-size: 18px;
    line-height: 18px;
    /* identical to box height, or 100% */
    
    /* default/blue/600 */
    color: var(--color-blue-600);
`;

const RepresentativeStatus = styled.div`
    margin-bottom: 12px;
    /* identical to box height, or 100% */
    
    /* default/green/700 */
    color: #2F855A;
`;

const RepresentativeInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const styles = {
  margin: {
      marginBottom: "12px"
  }
};

function RepresentativeLineItem({firstName, middleName, lastName, email, contactNumber, active, type, onMoreButtonClick}) {

    return (
        <Wrapper>
            <RepresentativeWrapper>
                <RepresentativeTitle>{firstName} {middleName} {lastName}</RepresentativeTitle>
                <RepresentativeInfo>
                    <div>
                        {
                            active ? <div style={{...styles.margin, color: "#2F855A"}}>Active</div>
                                : <div style={{...styles.margin, color: "#A0AEC0"}}>Inactive</div>
                        }


                        <div>{type}</div>
                    </div>

                    <div>
                        <div style={{...styles.margin, float: "right"}}>{contactNumber}</div>
                        <div>{email}</div>
                    </div>
                </RepresentativeInfo>
            </RepresentativeWrapper>

            <div style={{
                alignSelf: "center",
                marginLeft: "24px"}}
            >
                <IconButton onClick={onMoreButtonClick}>
                    <Icon fontSize={"large"}>more_vert</Icon>
                </IconButton>
            </div>
        </Wrapper>
    );
}

RepresentativeLineItem.propTypes = {};
RepresentativeLineItem.defaultProps = {};

export default RepresentativeLineItem;
